export const JSM_EMAIL_DOMAINS_LIST = 'JSM_EMAIL_DOMAINS_LIST';
